import React from 'react'

export const AppContext = React.createContext()

const AppContextProvider = ({children}) => {
    
    const [ data, setData ] = React.useState([])
    const [ isLoading, setIsLoading ] = React.useState(false)
    const [ isErorr, setIsError ] = React.useState(false)
    const value = { data, setData, isLoading, setIsLoading, isErorr, setIsError }
    return <AppContext.Provider value={ value }> {children} </AppContext.Provider>
}

export { AppContextProvider } 
